(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["al-blackout-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = '[data-blackout-header]';

    const QUICK_TARGETS = {
      offers: '[id^="BlackoutOffers-"]',
      led: '[id^="BlackoutLedOffer-"]',
      routines: '[id^="BlackoutRoutines-"]',
      products: '[id^="BlackoutCollectionTabs-"]'
    };

    const pad = (value) => {
      return String(Math.max(0, value)).padStart(2, '0');
    };

    const parseTime = (value) => {
      const parsed = new Date((value || '').trim()).getTime();

      return Number.isFinite(parsed)
        ? parsed
        : null;
    };

    const setText = (root, selector, value) => {
      root.querySelectorAll(selector).forEach((element) => {
        element.textContent = value || '';
        element.hidden = !value;
      });
    };

    const setCountdownVisibility = (root, visible) => {
      root
        .querySelectorAll('[data-announcement-countdown], [data-countdown-separator]')
        .forEach((element) => {
          element.hidden = !visible;
        });
    };

    const resolveQuickTarget = (key) => {
      const selector = QUICK_TARGETS[key];

      return selector
        ? document.querySelector(selector)
        : null;
    };

    const getHeaderOffset = (root) => {
      const stickySection = root.closest('.shopify-section');
      const headerHeight = stickySection
        ? stickySection.getBoundingClientRect().height
        : root.getBoundingClientRect().height;

      return Math.ceil(headerHeight + 12);
    };

    const setQuickLinkActive = (root, activeKey = '') => {
      root.querySelectorAll('[data-blackout-quick-link]').forEach((link) => {
        const isActive = link.dataset.quickKey === activeKey;

        link.classList.toggle('is-active', isActive);

        if (isActive) {
          link.setAttribute('aria-current', 'location');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    const updateQuickNav = (root) => {
      if (!root) return;

      const quickNav = root.querySelector('[data-blackout-quicknav]');
      const announcementView = root.querySelector('[data-blackout-announcement-view]');

      if (!quickNav || root.dataset.quickNavEnabled !== 'true') {
        root.dataset.quickNavActive = 'false';
        return;
      }

      const availableTargets = Object.keys(QUICK_TARGETS)
        .map((key) => ({
          key,
          element: resolveQuickTarget(key)
        }))
        .filter((item) => item.element);

      const hasTargets = availableTargets.length > 0;

      root.dataset.quickNavAvailable = hasTargets
        ? 'true'
        : 'false';

      const threshold = Number.parseInt(
        root.dataset.quickNavStart || '320',
        10
      );

      const shouldShow =
        hasTargets &&
        window.scrollY >= threshold;

      root.dataset.quickNavActive = shouldShow
        ? 'true'
        : 'false';

      quickNav.setAttribute(
        'aria-hidden',
        shouldShow ? 'false' : 'true'
      );

      if (announcementView) {
        announcementView.setAttribute(
          'aria-hidden',
          shouldShow ? 'true' : 'false'
        );
      }

      if (!shouldShow) {
        setQuickLinkActive(root);
        return;
      }

      const probe =
        window.scrollY +
        getHeaderOffset(root) +
        56;

      let activeKey = '';

      availableTargets.forEach(({ key, element }) => {
        const targetTop =
          element.getBoundingClientRect().top +
          window.scrollY;

        if (targetTop <= probe) {
          activeKey = key;
        }
      });

      setQuickLinkActive(root, activeKey);
    };

    const scheduleQuickNavUpdate = (root) => {
      if (!root || root.__blackoutHeaderScrollFrame) return;

      root.__blackoutHeaderScrollFrame =
        window.requestAnimationFrame(() => {
          root.__blackoutHeaderScrollFrame = null;
          updateQuickNav(root);
        });
    };

    const bindQuickNav = (root) => {
      if (!root || root.dataset.quickNavEnabled !== 'true') return;

      const quickNav = root.querySelector('[data-blackout-quicknav]');

      if (!quickNav) return;

      const clickHandler = (event) => {
        const link = event.target.closest('[data-blackout-quick-link]');

        if (!link || !root.contains(link)) return;

        const target = resolveQuickTarget(link.dataset.quickKey);

        event.preventDefault();

        if (!target) return;

        const top =
          target.getBoundingClientRect().top +
          window.scrollY -
          getHeaderOffset(root);

        window.scrollTo({
          top: Math.max(0, top),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth'
        });
      };

      const scrollHandler = () => {
        scheduleQuickNavUpdate(root);
      };

      root.addEventListener('click', clickHandler);
      window.addEventListener('scroll', scrollHandler, { passive: true });
      window.addEventListener('resize', scrollHandler, { passive: true });

      root.__blackoutHeaderQuickClick = clickHandler;
      root.__blackoutHeaderScrollHandler = scrollHandler;

      updateQuickNav(root);
    };

    const clearRoot = (root) => {
      if (!root) return;

      if (root.__blackoutHeaderTimer) {
        window.clearInterval(root.__blackoutHeaderTimer);
        root.__blackoutHeaderTimer = null;
      }

      if (root.__blackoutHeaderScrollFrame) {
        window.cancelAnimationFrame(root.__blackoutHeaderScrollFrame);
        root.__blackoutHeaderScrollFrame = null;
      }

      if (root.__blackoutHeaderQuickClick) {
        root.removeEventListener(
          'click',
          root.__blackoutHeaderQuickClick
        );

        root.__blackoutHeaderQuickClick = null;
      }

      if (root.__blackoutHeaderScrollHandler) {
        window.removeEventListener(
          'scroll',
          root.__blackoutHeaderScrollHandler
        );

        window.removeEventListener(
          'resize',
          root.__blackoutHeaderScrollHandler
        );

        root.__blackoutHeaderScrollHandler = null;
      }
    };

    const getPhase = (root) => {
      const now = Date.now();

      const earlyEnd = parseTime(root.dataset.earlyAccessEnd);
      const campaignEnd = parseTime(root.dataset.campaignEnd);

      if (campaignEnd && now >= campaignEnd) {
        return {
          name: 'ended',
          target: null,
          lead: root.dataset.endedLead || 'BLACKOUT WEEK',
          note: root.dataset.endedNote || 'КАМПАНИЯТА ПРИКЛЮЧИ',
          prefix: ''
        };
      }

      if (earlyEnd && now >= earlyEnd) {
        return {
          name: 'public',
          target: campaignEnd,
          lead: root.dataset.publicLead || 'BLACKOUT WEEK',
          note: root.dataset.publicNote || 'ДО ИЗЧЕРПВАНЕ',
          prefix: root.dataset.publicCountdownPrefix || 'КРАЙ СЛЕД'
        };
      }

      return {
        name: 'early',
        target: earlyEnd,
        lead: root.dataset.earlyLead || 'РАНЕН ДОСТЪП',
        note: root.dataset.earlyNote || '24 ЧАСА ПРЕДИ ВСИЧКИ',
        prefix: root.dataset.earlyCountdownPrefix || 'ОСТАВАТ'
      };
    };

    const render = (root) => {
      if (!root) return;

      const phase = getPhase(root);

      root.dataset.blackoutPhase = phase.name;

      setText(
        root,
        '[data-phase-lead]',
        phase.lead
      );

      setText(
        root,
        '[data-phase-note]',
        phase.note
      );

      setText(
        root,
        '[data-countdown-prefix]',
        phase.prefix
      );

      if (!phase.target) {
        setCountdownVisibility(root, false);
        return;
      }

      setCountdownVisibility(root, true);

      const remaining = Math.max(
        0,
        phase.target - Date.now()
      );

      const totalMinutes = Math.floor(
        remaining / 60000
      );

      const days = Math.floor(
        totalMinutes / 1440
      );

      const hours = Math.floor(
        (totalMinutes % 1440) / 60
      );

      const minutes =
        totalMinutes % 60;

      root
        .querySelectorAll('[data-announcement-days]')
        .forEach((element) => {
          element.textContent = pad(days);
        });

      root
        .querySelectorAll('[data-announcement-hours]')
        .forEach((element) => {
          element.textContent = pad(hours);
        });

      root
        .querySelectorAll('[data-announcement-minutes]')
        .forEach((element) => {
          element.textContent = pad(minutes);
        });
    };

    const initRoot = (root) => {
      if (!root) return;

      clearRoot(root);
      render(root);
      bindQuickNav(root);

      root.__blackoutHeaderTimer = window.setInterval(() => {
        render(root);
      }, 30000);
    };

    const initAll = (scope = document) => {
      if (
        scope.matches &&
        scope.matches(ROOT_SELECTOR)
      ) {
        initRoot(scope);
      }

      scope
        .querySelectorAll?.(ROOT_SELECTOR)
        .forEach(initRoot);
    };

    initAll();

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initAll(event.target);
      }
    );

    document.addEventListener(
      'shopify:section:unload',
      (event) => {
        const root =
          event.target.matches?.(ROOT_SELECTOR)
            ? event.target
            : event.target.querySelector?.(
                ROOT_SELECTOR
              );

        clearRoot(root);
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["al-blackout-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = '[data-blackout-hero]';

    const pad = (value) => String(value).padStart(2, '0');

    const clearCountdown = (root) => {
      if (root && root.__blackoutCountdownInterval) {
        window.clearInterval(root.__blackoutCountdownInterval);
        root.__blackoutCountdownInterval = null;
      }
    };

    const initCountdown = (root) => {
      if (!root) return;

      clearCountdown(root);

      const timer = root.querySelector('[data-blackout-countdown]');
      if (!timer) return;

      const endTimeRaw = (timer.dataset.endTime || '').trim();
      const endTime = new Date(endTimeRaw).getTime();

      const grid = timer.querySelector('[data-countdown-grid]');
      const expiredMessage = timer.querySelector('[data-countdown-expired]');
      const daysElement = timer.querySelector('[data-days]');
      const hoursElement = timer.querySelector('[data-hours]');
      const minutesElement = timer.querySelector('[data-minutes]');
      const secondsElement = timer.querySelector('[data-seconds]');
      const expiredBehavior = timer.dataset.expiredBehavior || 'message';

      timer.removeAttribute('hidden');

      if (grid) grid.removeAttribute('hidden');
      if (expiredMessage) expiredMessage.setAttribute('hidden', '');

      if (!Number.isFinite(endTime)) {
        timer.setAttribute('hidden', '');
        return;
      }

      const renderExpired = () => {
        if (daysElement) daysElement.textContent = '00';
        if (hoursElement) hoursElement.textContent = '00';
        if (minutesElement) minutesElement.textContent = '00';
        if (secondsElement) secondsElement.textContent = '00';

        if (expiredBehavior === 'hide') {
          timer.setAttribute('hidden', '');
        }

        if (expiredBehavior === 'message') {
          if (grid) grid.setAttribute('hidden', '');
          if (expiredMessage) expiredMessage.removeAttribute('hidden');
        }

        clearCountdown(root);
      };

      const updateCountdown = () => {
        const remaining = endTime - Date.now();

        if (remaining <= 0) {
          renderExpired();
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        if (daysElement) daysElement.textContent = pad(days);
        if (hoursElement) hoursElement.textContent = pad(hours);
        if (minutesElement) minutesElement.textContent = pad(minutes);
        if (secondsElement) secondsElement.textContent = pad(seconds);
      };

      updateCountdown();
      root.__blackoutCountdownInterval = window.setInterval(updateCountdown, 1000);
    };

    const initAll = (scope = document) => {
      if (scope.matches && scope.matches(ROOT_SELECTOR)) {
        initCountdown(scope);
      }

      scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initCountdown);
    };

    initAll();

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.querySelector?.(ROOT_SELECTOR);

      if (root) {
        clearCountdown(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
